import { useEntity } from '@backstage/plugin-catalog-react';
import { isMarketplaceAiResourceEntity } from '@backstage/catalog-model/alpha';
import { Link } from '@backstage/ui';

import { getMarketplaceRepoSlug } from './getMarketplaceRepoSlug';
import { InstallCard } from './InstallCard';

const COPILOT_CLI_INSTALL_URL =
  'https://docs.github.com/en/copilot/how-tos/set-up/install-copilot-cli';

const copilotCliLink = (
  <Link href={COPILOT_CLI_INSTALL_URL} target="_blank" rel="noreferrer">
    GitHub Copilot CLI
  </Link>
);

export const MarketplaceInstallCard = () => {
  const { entity } = useEntity();

  if (!isMarketplaceAiResourceEntity(entity)) {
    return null;
  }

  const repoSlug = getMarketplaceRepoSlug(entity) ?? 'OWNER/REPO';

  return (
    <InstallCard
      warning="Make sure you trust the owner of this marketplace and that you know what you are installing."
      requires={copilotCliLink}
      command={`copilot plugin marketplace add ${repoSlug}`}
    />
  );
};
